/**
 * Telemetry-style page header — consistent HUD aesthetic across all pages.
 * Uses monospace for status labels, sans-serif for main title only.
 */

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Status dot color variant */
  status?: 'blue' | 'green' | 'amber' | 'red';
  /** Override the system status label */
  statusLabel?: string;
  /** Right-aligned action slot */
  actions?: React.ReactNode;
}

export function PageHeader({
  title,
  subtitle,
  status = 'blue',
  statusLabel = 'SYSTEM STATUS: ACTIVE',
  actions,
}: PageHeaderProps) {
  return (
    <div className="flex items-start justify-between mb-6">
      <div>
        <div className="flex items-center gap-3 mb-1">
          <div className={`telemetry-dot telemetry-dot--${status}`} />
          <span className="text-[10px] font-mono tracking-[0.15em] uppercase text-slate-500">
            {statusLabel}
          </span>
        </div>
        <h1 className="text-2xl md:text-3xl font-light tracking-tight text-slate-200">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[11px] font-mono tracking-[0.1em] text-slate-500 mt-1 uppercase">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
